import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetStatsEnvironment } from '../fleet-stats-environment';
import { vehicleStatsSchema } from '../schemas/vehicle-stats.schema';

/**
 * Gets all vehicles with unassigned vehicle groups in an account
 * @returns Vehicles with unassigned vehicle groups
 */
export function getDashboardVehicleStatsUnassignedVehicleGroups(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetStatsEnvironment.resolve(
          this
        ).dashboardVehicleStatsUnassignedVehicleGroupsUrl,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(z.array(vehicleStatsSchema)));
}
